/** Created by azhou on 2019/3/18.*/
<template>
  <div>
    <ul class="list-item">
      <li class="w-50 list-item-col flex-wrap">
        <el-popover placement="right" trigger="hover">
          {{cardItem.oid}}<span slot="reference">{{cardItem.oid | formatString(13)}}</span>
        </el-popover>
        <el-popover class="w-100" placement="right" trigger="hover" v-if="storeInfo.type != 2">
            {{cardItem.company}}
            <span slot="reference">
              {{cardItem.company | formatString(10)}}<label class="text-warning" v-if="cardItem.utype == 4">(导游)</label>
            </span>
        </el-popover>
        <el-popover placement="right" trigger="hover" v-if="storeInfo.type == 99" class="w-100">
            {{cardItem.store_name}}<span slot="reference">{{cardItem.store_name | formatString(10)}}</span>
        </el-popover>
        <el-popover placement="right" trigger="hover" v-if="storeInfo.type == 2" class="w-100">
            {{cardItem.viewpointTitle}}<span slot="reference">{{cardItem.viewpointTitle | formatString(10)}}</span>
        </el-popover>
      </li>
      <li class="w-50 list-item-col" v-if="isGroup">{{cardItem.store_name || cardItem.company}}</li>
      <li class="w-50 list-item-col">{{cardItem.date_in | formatTimestamp}}</li>
      <li class="w-50 list-item-col flex-column">{{cardItem.order_type | formatVar('ticketTopType')}}<span>{{TicketType}}</span></li>
      <li class="w-50 list-item-col">{{cardItem.time | formatTimestamp(1)}}</li>
      <li class="w-50 list-item-col">
        {{cardItem.guide_name || '待添加'}}<br />
        {{cardItem.guide_mobile}}
      </li>
      <li class="w-50 list-item-col flex-column">
        <div class="text-dark">&yen;{{cardItem.price}}</div>
        <div class="text-success">&yen;{{(cardItem.price_pay / 100).toFixed(2)}}</div>
      </li>
      <li class="w-50 list-item-col"><span :class="[$GFUN.FormatColor(cardItem.status)]">{{cardItem.status | formatVar('SOrderStatus')}}</span></li>
      <li class="w-50 list-item-col"><span class="text-link" @click="$emit('goForDetail',cardItem)">查看</span></li>
    </ul>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'ScenicOrderCard',
    props: {
      cardItem: {}
    },
    computed: {
      ...mapGetters(['storeInfo','isGroup']),
      TicketType() {
        //if (this.cardItem.order_type === 5) return '';
        if (!this.cardItem.ticket_arr) return '';
        let ticketTypeName = [];
        this.cardItem.ticket_arr.forEach(v => {
          let t = this.$options.filters['formatVar'](v.ticket_type,'ticketTypeArr');
          ticketTypeName.push(t);
        });
        return ticketTypeName.join(',');
      }
    },
  }
</script>

<style lang="scss" scoped>
.list-item-col{
  border-right: 0;
}
</style>
